import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbsenceCollision } from '@qaroni-app/absences/types/absence-collision';
import { AbsenceUnitEnum } from '@qaroni-app/absences/types/absence-unit.enum';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';

@Component({
  selector: 'qaroni-absence-employee-warnings',
  templateUrl: './absence-employee-warnings.component.html',
  styleUrl: './absence-employee-warnings.component.scss',
  animations: [qaroniAnimations.toggleHeight()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsenceEmployeeWarningsComponent {
  readonly collision = input<AbsenceCollision | null>(null);
  readonly unit = input<AbsenceUnitEnum | null>(null);
  readonly fileRequired = input<boolean>(false);
  readonly extraCount = input<number>(0);

  public totalCollisionMapping = {
    '=1': $localize`colisión`,
    other: $localize`colisiones`,
  };

  get hasCollisionWarning(): boolean {
    return !!this.collision()?.flagError || !!this.collision()?.totalCollision;
  }

  get warningsCount(): number {
    return (
      (this.hasCollisionWarning ? 1 : 0) +
      (this.fileRequired() ? 1 : 0) +
      this.extraCount()
    );
  }
}
